import Vue from 'vue';
import Vuex from 'vuex';
import commondata from "./CommonData";
import getters from "./getters";
Vue.use(Vuex);
export default new Vuex.Store({
  modules:{
    commondata
  },
  getters
}) 


// WEBPACK FOOTER //
// ./src/store/index.js